module.exports = __webpack_public_path__ + "static/media/products2_190415.d01e2694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/unused/products2_190415.jpg
// module id = 728
// module chunks = 0